import styles from '@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less'
import React, {useContext, useState, useMemo, useEffect} from "react";
import {useSetState} from "ahooks";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import dayjs from "dayjs";
import {Button, Col, Popover, Row, Tabs, Tooltip} from "antd";
import { STitle } from 'shj-components';
import AddOrEditTrack from "@/pages/clueManage/clueDetail/components/Modals/AddOrEditTrack";
import {FormOutlined, DoubleRightOutlined} from "@ant-design/icons";
import {iiHOC} from "@/utils/auth.ts";
import classNames from "classnames";
import {measureTagConfig} from "@/pages/roomMeasurementTools/roomMeasurementManage/components/List/list.tsx";
import {ViewMeasureReport} from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/ViewMeasureReport.tsx";
import {salesBenchJumpToProject} from "@/services/pms.ts";
import {get} from "lodash-es";
import {useNavigate} from "react-router-dom";

const BizTypeInfo = () => {
  const navigate = useNavigate()
  const {detailState, updateDetail, isWorkBench} = useContext(ClueDetailContext);
  const [state, setState] = useSetState<any>({
    open: false,
    viewReportOpen: false,
    currentTrackProjectId: '',
  });
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    if(detailState.templateNodeId) getProjectId()
  }, [detailState.templateNodeId]);

  const getProjectId = () => {
    salesBenchJumpToProject({trackPlanId: detailState.templateNodeId}).then(res => {
      setState({currentTrackProjectId: get(res, '[0].projectId', '')})
    }).catch(() => setState({currentTrackProjectId: ''}))
  }

  const getFormEle = (detail) => {
    return <Row>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>商机ID：</span>
        <Tooltip title={detail.id}>
          <span className={classNames([styles.value, styles.valueEllipsis])}>{detail.id}</span>
        </Tooltip>
      </Col>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>商机状态：</span>
        <span className={styles.value}>{detail?.statusDesc}</span>
      </Col>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>需求标签：</span>
        <span className={styles.value}>{detail?.bizTypeName}</span>
      </Col>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>产品意向：</span>
        <span className={styles.value}>{detail?.intentionProductName}</span>
      </Col>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>签单意向：</span>
        <span className={styles.value}>{detail?.signIntentionName}</span>
      </Col>
      <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
        <span className={styles.label}>最近预约见面时间：</span>
        <Tooltip title={detail?.lastAppointmentTime ? dayjs(detail?.lastAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : ''}>
          <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.lastAppointmentTime ? dayjs(detail?.lastAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
        </Tooltip>
      </Col>
      {
        isExpand ? (
          <>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>最近见面时间：</span>
              <Tooltip title={detail?.lastArriveTime ? dayjs(detail?.lastArriveTime).format('YYYY-MM-DD HH:mm:ss') : ''}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.lastArriveTime ? dayjs(detail?.lastArriveTime).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>预计签单时间：</span>
              <Tooltip title={detail?.expectSignTime && dayjs(detail?.expectSignTime).format('YYYY-MM-DD')}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.expectSignTime && dayjs(detail?.expectSignTime).format('YYYY-MM-DD')}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>预计签单金额：</span>
              <span className={styles.value}>{detail?.expectSignAmount}</span>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>预计进场装修时间：</span>
              <Tooltip title={detail?.expectRenovationDate && dayjs(detail?.expectRenovationDate).format('YYYY-MM-DD')}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.expectRenovationDate && dayjs(detail?.expectRenovationDate).format('YYYY-MM-DD')}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>痛点：</span>
              <Tooltip title={detail?.painPointName}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.painPointName}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>痛点备注：</span>
              <Tooltip title={detail?.painPoinRemark}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.painPoinRemark || '-'}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>痒点：</span>
              <Tooltip title={detail?.itchPointName}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.itchPointName}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>痒点备注：</span>
              <Tooltip title={detail?.itchPoinRemark}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.itchPoinRemark || '-'}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>障碍点：</span>
              <Tooltip title={detail?.blockPointName}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.blockPointName}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>障碍点备注：</span>
              <Tooltip title={detail?.blockPointRemark}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.blockPointRemark || '-'}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>爆破点：</span>
              <Tooltip title={detail?.breakPointName}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.breakPointName}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>爆破点备注：</span>
              <Tooltip title={detail?.breakPointRemark}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.breakPointRemark || '-'}</span>
              </Tooltip>
            </Col>
            <Col span={8} className={classNames([styles.mb10, styles.flexStartCenter])}>
              <span className={styles.label}>备注：</span>
              <Tooltip title={detail?.remark}>
                <span className={classNames([styles.value, styles.valueEllipsis])}>{detail?.remark}</span>
              </Tooltip>
            </Col>
          </>
        ) : null
      }
    </Row>
  }

  const handleExpandOrCollapse = () => {
    console.log(1234)
    setIsExpand(!isExpand);
  }

  const tabList = useMemo(() => {
    return detailState.trackTabs?.map((item) => {
      return {
        key: item.id,
        label: item.bizTypeName,
        children: (<>
          <STitle style={{ marginBottom: 10 }} title="客户标签" />
          {getFormEle(item)}
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--theme-color)', cursor: 'pointer' }}
            onClick={handleExpandOrCollapse}
          >
            {
              !isExpand ? (
                <>
                  <DoubleRightOutlined style={{ transform: 'rotate(90deg)', marginRight: '5px' }} />
                  查看更多
                </>
              ) : (
                <>
                  <DoubleRightOutlined style={{ transform: 'rotate(-90deg)', marginRight: '5px' }} />
                  收起
                </>
              )
            }
          </div>
        </>)
      }
    })
  }, [detailState.trackTabs, isExpand])

  const detail = useMemo(() => {
    return detailState.trackTabs?.find(item => item.id === detailState.templateNodeId)
  }, [detailState.trackTabs, detailState.templateNodeId])

  const onEdit = ()=>  {
    // const current = state.tabs?.find(item => item.id === state.activeKey)
    setState({open: true})
  }

  const onJumpToProjectDetail = () => {
    navigate(`/pms/projectPlus/projectDetail/${state.currentTrackProjectId}`)
  }

  const content = (<div>
    <p style={{marginBottom: 5}}>量房状态：{measureTagConfig[detail?.measureRoomVo?.status]?.label || '-'}</p>
    <p style={{marginBottom: 5}}>预约量房时间：{detail?.measureRoomVo?.appointmentTime ? dayjs(detail?.measureRoomVo?.appointmentTime).format('YYYY-MM-DD HH:mm:ss') : '-'}</p>
    <p style={{marginBottom: 5}}>实际量房时间：{detail?.measureRoomVo?.actualMeasureTime ? dayjs(detail?.measureRoomVo?.actualMeasureTime).format('YYYY-MM-DD HH:mm:ss') : '-'}</p>
    <p>量房报告：{['completed'].includes(detail?.measureRoomVo?.status)  ?
        <Button type={'link'} onClick={() => {setState({viewReportOpen: true, record: {...detail?.measureRoomVo, id: detail?.measureRoomVo?.measureRoomId, tenantId: detail?.tenantId}})}}>查看</Button> : '-'}</p>
  </div>)

  const editBtn = () => {
    return <div style={{display: 'flex', alignItems: 'center'}}>
      <Popover content={content} title={null}>
        {detail?.measureRoomVo ? <Button type="link">查看量房状态</Button> : null}
      </Popover>
      {state.currentTrackProjectId && <Button style={{margin: '0 10px'}} onClick={onJumpToProjectDetail}>工地详情</Button>}
      {iiHOC(<Button onClick={onEdit} datareskey={'salesWorkBenchTrackInfoEdit'}><FormOutlined />编辑</Button>)}
    </div>
  }

  return <div>
    {detailState.trackTabs?.length ?
      <Tabs
        activeKey={detailState.templateNodeId}
        items={tabList}
        tabBarExtraContent={isWorkBench ?
            editBtn()
          : null
        }
        onChange={(key) => {
          const current = detailState.trackTabs?.find(item => item.id === key)
          updateDetail({
            templateStepId: current?.salesTemplateId,
            currentTemplateStepId: current?.currentNodeId,
            templateNodeId: current?.id
          })
        }}
      /> : null}
    { state.open && <AddOrEditTrack basicInfo={detail}
                                    editReload={() => {}}
                                    reload={() => updateDetail({isReloadTrackTab: !detailState.isReloadTrackTab})}
                                    isEdit={true}
                                    open={state.open}
                                    onClose={() => setState({open: false})} /> }
    {/* 查看量房报告 */}
    <ViewMeasureReport open={state?.viewReportOpen} onClose={() => setState({viewReportOpen: false})} record={state.record}/>
  </div>
}

export default BizTypeInfo